import React from 'react';


const HeaderTopS2 = () => {
    return (
        <div className="topbar s2">
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-12 col-12">
                        <div className="contyact-info-wrap">
                            <div className="contact-info">
                                <div className="icon">
                                    <i className="fi flaticon-phone-call"></i>
                                </div>
                                <div className="info-text">
                                    <span>Телефон:</span>
                                    <p>+992 92 798 79 99</p>
                                </div>
                            </div>
                            <div className="contact-info">
                                <div className="icon">
                                    <i className="fi flaticon-email"></i>
                                </div>
                                <div className="info-text">
                                    <span>E-mail:</span>
                                    <p>tezroh@mail.ru</p>
                                </div>
                            </div>

                            <div className="contact-info">
                                <div className="icon">
                                    <i className="fi flaticon-location-1"></i>
                                </div>
                                <div className="info-text">
                                    <span>Локация:</span>
                                    <p>ҷ.Хистеварз кӯчаи Дӯсти № 111,<br />
                                        в. Сугд н. Б.Гафуров </p>
                                </div>
                            </div>

                            <div className="contact-info ms-5">
                                <div className="info-text">
                                    <span><a href="#/">RU</a></span>
                                </div>
                                <div className="info-text">
                                    <span><a href="https://en.mml.tj/">EN</a></span>

                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>

    );
};

export default HeaderTopS2;